export const DNM_ROLE_MAPPINGS_OPTIONS = [
  "id",
  "dealerColumn",
  "descriptionInDnm",
  "csvColumn",
  "descriptionInPd",
  "createdAt",
  "updatedAt",
];
